import React, { useState } from "react";
import { CREAM, LINE, BURGUNDY, INK_2 } from "../bureauTokens";

function ProfileTab({ p, active, onChange }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      onClick={() => onChange(p.id)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="inline-flex items-center gap-1.5 whitespace-nowrap transition-colors"
      style={{
        padding: "6px 13px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: active ? 600 : 500,
        color: active ? "#fff" : hover ? BURGUNDY : INK_2,
        background: active ? BURGUNDY : "transparent",
        boxShadow: active ? "0 1px 3px rgba(110,26,54,.25)" : "none",
      }}
    >
      <p.icon size={14} style={{ opacity: active ? 1 : 0.75 }} />
      {p.label}
    </button>
  );
}

function ProfileSwitcher({ profiles, active, onChange }) {
  return (
    <div
      className="inline-flex flex-wrap"
      style={{ gap: 2, background: CREAM, border: `1px solid ${LINE}`, borderRadius: 999, padding: 3 }}
    >
      {profiles.map((p) => (
        <ProfileTab key={p.id} p={p} active={active === p.id} onChange={onChange} />
      ))}
    </div>
  );
}

export default ProfileSwitcher;
